import React from "react";

const BlogNavigation = ({ onNavigate, label, className = "" }) => {
  return (
    <div className={`blog-back click ${className}`}>
      <h4 className="blogger-name click grey" onClick={onNavigate}>
        {label}
      </h4>
    </div>
  );
};

export default BlogNavigation;
